import cn from "classnames";
import style from "./TableRow.module.scss";
import { useRef, useState } from "react";
import { Chip } from "@ui";
import { CostsByTag } from "@interfaces/admin/costsByTag";

function* colorGenerator() {
    const colors = ["purple", "orange", "blue", "green"];
    let index = 0;
    while (true) {
        yield colors[index];
        index = (index + 1) % colors.length;
    }
}

const generator = colorGenerator();

export function TableRow({
    data
}: {
    data: CostsByTag
}) {
    const [showChildren, setShowChildren] = useState<boolean>(false);

    const { current: color } = useRef(generator.next().value as unknown as "purple" | "orange" | "red" | "blue" | "green")

    return (
        <div className={style.row}>
            <div className={style.cell}>
                <div
                    className={cn("flex items-center select-none gap-[7px]", data.costs.length > 0 && "cursor-pointer")}
                    onClick={() => {
                        if (data.costs.length > 0) {
                            setShowChildren((state) => !state)
                        }
                    }}
                >
                    {
                        data.costs.length > 0
                            ? <svg className={showChildren ? "rotate-[180deg]" : "rotate-[0]"} xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                <path d="M5.50503 3.00503C5.77839 2.73166 6.22161 2.73166 6.49497 3.00503L10.9497 7.4598C11.2231 7.73317 11.2231 8.17638 10.9497 8.44975C10.6764 8.72311 10.2332 8.72311 9.9598 8.44975L6 4.48995L2.0402 8.44975C1.76684 8.72311 1.32362 8.72311 1.05025 8.44975C0.776885 8.17638 0.776885 7.73316 1.05025 7.4598L5.50503 3.00503ZM5.3 4.5L5.3 3.5L6.7 3.5L6.7 4.5L5.3 4.5Z" fill="#A2AFD0" />
                            </svg>
                            : null
                    }
                    <Chip
                        text={"#" + data.tag_name}
                        size="small"
                        color={color}
                    />
                </div>
            </div>
            <div className={style.cell}>
                <div className={style.sum}>
                    <span className="text-[#686D81] truncate">$ {data.total_sum_usd}</span>
                    <span>/</span>
                    <span className="truncate">{data.total_sum_hryvna} ₴</span>
                </div>
            </div>
            <div className={cn(style.children, showChildren && style.children_show)}>
                {
                    data.costs.map((child, i) => (
                        <div key={i} className={cn(style.row, "!p-[0] !pt-[15px] !border-none")}>
                            <div className={cn(style.cell, "pl-[37px] gap-[5px]")}>
                                <Chip
                                    text={child.created_at.split("T")[0].split("-").reverse().join(".")}
                                    size="small"
                                    variant="outline"
                                    color={color}
                                />
                                <Chip
                                    text={"#" + child.tag_name}
                                    size="small"
                                    color={color}
                                />
                            </div>
                            <div className={style.cell}>
                                <div className={style.sum}>
                                    <span className="text-[#686D81] truncate">$ {child.sum_usd}</span>
                                    <span>/</span>
                                    <span className="truncate">{child.sum_hryvna} ₴</span>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

